<template>
  <el-upload
    class="app-img-uploader"
    :class="[ `app-img-uploader--${size}` ]"
    :action="action"
    :show-file-list="false"
    :on-success="handleUploadSuccess"
    :before-upload="handleBeforeUpload">
    <img class="app-img-uploader__preview" v-if="imageUrl" :src="imageUrl">
    <i class="el-icon-plus app-img-uploader__icon" v-else></i>
  </el-upload>
</template>

<script>
export default {
  name: 'AppImgUploader',
  props: {
    action: {
      type: String,
      default: process.env.VUE_APP_IMG_SERVER
    },
    image: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'default'
    }
  },

  data () {
    return {
      imageUrl: this.image
    }
  },

  watch: {
    image (newValue, oldValue) {
      this.imageUrl = newValue
    }
  },

  methods: {
    handleUploadSuccess (res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
      this.$emit('success', res)
    },

    handleBeforeUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = (file.size / 1024 / 1024) < 2

      if (!isJPG && !isPNG) {
        this.$message.error('只能上传 .jpg、.jpeg 以及 .png 格式的图片！')
      }

      if (!isLt2M) {
        this.$message.error('只能上传大小小于2MB的图片！')
      }

      return (isJPG || isPNG) && isLt2M
    }
  }
}
</script>

<style lang="scss">
$parent: '.app-img-uploader';

#{$parent} {
  .el-upload {
    position: relative;
    overflow: hidden;
    border: 1px dashed #ccc;
    border-radius: 6px;
    cursor: pointer;

    &:hover {
      border-color: $primary-color;
    }
  }

  &--small {
    #{$parent}__icon {
      width: 80px;
      height: 80px;
      line-height: 80px;
    }

    #{$parent}__preview {
      width: 80px;
      height: 80px;
    }
  }

  &__icon {
    font-size: 28px;
    color: #999;
    width: 118px;
    height: 118px;
    line-height: 118px;
    text-align: center;
  }

  &__preview {
    display: block;
    width: 118px;
    height: 118px;
    object-fit: cover;
  }
}
</style>
